import { useMutation, useQueryClient } from '@tanstack/react-query'
import { updateOrgBranding, type OrgBrandingUpdateRequest, type Organization } from '../lib/api'
import { useAppStore } from '../stores/app'

export function useOrgBranding() {
  const queryClient = useQueryClient()
  const organizationId = useAppStore((state) => state.organizationId)

  return useMutation({
    mutationFn: (data: OrgBrandingUpdateRequest) => updateOrgBranding(data),
    onSuccess: (updated: Organization) => {
      queryClient.setQueryData<Organization>(['organization', organizationId], updated)
    },
  })
}
